module.exports = __webpack_public_path__ + "media/sleep.bbb877e0.mp3";